import { colors } from "@dotnet/telematics-design-system";

export const inputPropsStyleOverrides = {
  color: colors.textDark,
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  borderRadius: "6px",

  "& input": {
    transitionDelay: "9999s",
    transitionProperty: "background-color"
  },

  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.gray400
    },

    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.red800
    },

    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.gray300
    }
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.gray300
  },

  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.gray300
  }
};

export const textFieldStyleOverrides = {
  "& .MuiFormHelperText-root": {
    margin: "6px 0 0",
    display: "inline-flex",
    alignItems: "center",
    color: colors.gray700,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "500",
    letterSpacing: "0.1px",

    "&.Mui-error": {
      color: colors.gray700
    }
  }
};
